import { Controller } from "@hotwired/stimulus"

// Righe aggiunte e tolte in un form (regole, requisiti, condizioni, link di Verifica bandi), al posto degli array
// nello stato React. Ogni riga è un elemento data-righe-target="riga"; una riga nuova viene dal <template>
// data-righe-target="modello", dove __INDICE__ sta per il numero della riga. Dopo ogni aggiunta o rimozione le righe
// sono rinumerate da 0 negli attributi `name`, `id`, `for` e `data-testid` («x[3][campo]» → «x[2][campo]»,
// «limite-3-esito» → «limite-2-esito»).
//   <div data-controller="righe"> <div data-righe-target="elenco">…righe…</div>
//     <template data-righe-target="modello">…__INDICE__…</template>
//     <button data-action="righe#aggiungi">Aggiungi</button> … <button data-action="righe#togli">Togli</button>
// Con i parametri dell'azione (data-righe-url-param="…") la riga nuova parte con quei valori nei campi il cui `name`
// finisce con «[url]» (es. «Aggiungi» di una pagina proposta). Dopo una rimozione l'evento "righe:tolta".
// Una riga arrivata da una risposta del server (turbo_stream.append, es. «Proponi dagli atti») con data-righe-nuova
// conta come aggiunta: "righe:aggiunta" anche per lei.
export default class extends Controller {
  static targets = ["elenco", "modello", "riga"]
  static ATTRIBUTI = ["name", "id", "for", "data-testid"]

  aggiungi(event) {
    event?.preventDefault()
    const html = this.modelloTarget.innerHTML.replaceAll("__INDICE__", String(this.rigaTargets.length))
    this.elencoTarget.insertAdjacentHTML("beforeend", html)
    const riga = this.rigaTargets[this.rigaTargets.length - 1]
    Object.entries(event?.params || {}).forEach(([campo, valore]) => {
      riga.querySelectorAll(`[name$="[${campo}]"]`).forEach((el) => { el.value = String(valore) })
    })
    this.dispatch("aggiunta", { detail: { riga } })
  }

  rigaTargetConnected(riga) {
    if (riga.dataset.righeNuova === undefined) return
    delete riga.dataset.righeNuova
    this.dispatch("aggiunta", { detail: { riga } })
  }

  togli(event) {
    event?.preventDefault()
    event?.currentTarget?.closest("[data-righe-target='riga']")?.remove()
    this.rinumera()
    this.dispatch("tolta")
  }

  rinumera() {
    this.rigaTargets.forEach((riga, nuovo) => {
      const vecchio = riga.dataset.righeIndice
      riga.dataset.righeIndice = String(nuovo)
      if (vecchio === undefined || vecchio === String(nuovo)) return
      const esatto = new RegExp(`\\[${vecchio}\\]|-${vecchio}(?=-|$)`, "g")
      const sostituisci = (s) => s.replace(esatto, (m) => (m.startsWith("[") ? `[${nuovo}]` : `-${nuovo}`))
      ;[riga, ...riga.querySelectorAll("*")].forEach((el) => {
        this.constructor.ATTRIBUTI.forEach((a) => {
          if (el.hasAttribute(a)) el.setAttribute(a, sostituisci(el.getAttribute(a)))
        })
      })
    })
  }
}
